// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XNlgAmOAkvrndqhQSeOw {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  position: relative;
}
.XNlgAmOAkvrndqhQSeOw._kNMDHyPE7Y2uykKeXzL {
  border-radius: var(--chips-sm-border-radius, var(--chips-border-radius));
}
.XNlgAmOAkvrndqhQSeOw._kNMDHyPE7Y2uykKeXzL .gI7SyPgTMjoBf0STdAwD {
  gap: var(--chips-sm-gap);
}
.XNlgAmOAkvrndqhQSeOw._kNMDHyPE7Y2uykKeXzL .ZMfJtfGwR8QpfGsEkDcQ {
  padding: var(--chips-sm-padding-vertical) var(--chips-sm-padding-horizontal);
}
.XNlgAmOAkvrndqhQSeOw._kNMDHyPE7Y2uykKeXzL.if88F_Hs1SDOjx4kBgZn .ZMfJtfGwR8QpfGsEkDcQ {
  padding: var(--chips-sm-padding-square);
  aspect-ratio: 1/1;
  width: min-content;
}
.XNlgAmOAkvrndqhQSeOw.iwPLQ9yqq_PvXBURHVU2 {
  border-radius: var(--chips-md-border-radius, var(--chips-border-radius));
}
.XNlgAmOAkvrndqhQSeOw.iwPLQ9yqq_PvXBURHVU2 .gI7SyPgTMjoBf0STdAwD {
  gap: var(--chips-md-gap);
}
.XNlgAmOAkvrndqhQSeOw.iwPLQ9yqq_PvXBURHVU2 .ZMfJtfGwR8QpfGsEkDcQ {
  padding: var(--chips-md-padding-vertical) var(--chips-md-padding-horizontal);
}
.XNlgAmOAkvrndqhQSeOw.iwPLQ9yqq_PvXBURHVU2.if88F_Hs1SDOjx4kBgZn .ZMfJtfGwR8QpfGsEkDcQ {
  padding: var(--chips-md-padding-square);
  aspect-ratio: 1/1;
  width: min-content;
}
.XNlgAmOAkvrndqhQSeOw.K8WRj_P93vnUooCkTtqW {
  border-radius: var(--chips-lg-border-radius, var(--chips-border-radius));
}
.XNlgAmOAkvrndqhQSeOw.K8WRj_P93vnUooCkTtqW .gI7SyPgTMjoBf0STdAwD {
  gap: var(--chips-lg-gap);
}
.XNlgAmOAkvrndqhQSeOw.K8WRj_P93vnUooCkTtqW .ZMfJtfGwR8QpfGsEkDcQ {
  padding: var(--chips-lg-padding-vertical) var(--chips-lg-padding-horizontal);
}
.XNlgAmOAkvrndqhQSeOw.K8WRj_P93vnUooCkTtqW.if88F_Hs1SDOjx4kBgZn .ZMfJtfGwR8QpfGsEkDcQ {
  padding: var(--chips-lg-padding-square);
  aspect-ratio: 1/1;
  width: min-content;
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe {
  background-color: var(--chips-input-default-bg);
  color: var(--chips-input-default-text);
  font-family: var(--chips-input-font-family, inherit);
  font-size: var(--chips-input-font-size, inherit);
  font-weight: var(--chips-input-font-weight, inherit);
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-input-default-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe:hover {
  background-color: var(--chips-input-hover-bg, var(--chips-input-default-bg));
  color: var(--chips-input-hover-text, var(--chips-input-default-text));
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe:hover .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-input-hover-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe:focus-visible {
  background-color: var(--chips-input-focused-bg, var(--chips-input-default-bg));
  color: var(--chips-input-focused-text, var(--chips-input-default-text));
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe:focus-visible .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-input-focused-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe:active, .XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe[data-active=true] {
  background-color: var(--chips-input-active-bg, var(--chips-input-default-bg));
  color: var(--chips-input-active-text, var(--chips-input-default-text));
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe:active .ZMfJtfGwR8QpfGsEkDcQ, .XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe[data-active=true] .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-input-active-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe[data-dragged=true] {
  background-color: var(--chips-input-dragged-bg, var(--chips-input-default-bg));
  color: var(--chips-input-dragged-text, var(--chips-input-default-text));
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe[data-dragged=true] .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-input-dragged-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe:disabled, .XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe[data-disabled=true] {
  background-color: var(--chips-input-disabled-bg, var(--chips-input-default-bg));
  color: var(--chips-input-disabled-text, var(--chips-input-default-text));
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe:disabled .ZMfJtfGwR8QpfGsEkDcQ, .XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe[data-disabled=true] .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-input-disabled-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.jqvs6fx1yRny94GEIdbe[data-loading=true] {
  opacity: 0.7;
  pointer-events: none;
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0 {
  background-color: var(--chips-input-selected-default-bg);
  color: var(--chips-input-selected-default-text);
  font-family: var(--chips-input-selected-font-family, inherit);
  font-size: var(--chips-input-selected-font-size, inherit);
  font-weight: var(--chips-input-selected-font-weight, inherit);
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0 .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-input-selected-default-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0:hover {
  background-color: var(--chips-input-selected-hover-bg, var(--chips-input-selected-default-bg));
  color: var(--chips-input-selected-hover-text, var(--chips-input-selected-default-text));
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0:hover .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-input-selected-hover-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0:focus-visible {
  background-color: var(--chips-input-selected-focused-bg, var(--chips-input-selected-default-bg));
  color: var(--chips-input-selected-focused-text, var(--chips-input-selected-default-text));
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0:focus-visible .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-input-selected-focused-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0:active, .XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0[data-active=true] {
  background-color: var(--chips-input-selected-active-bg, var(--chips-input-selected-default-bg));
  color: var(--chips-input-selected-active-text, var(--chips-input-selected-default-text));
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0:active .ZMfJtfGwR8QpfGsEkDcQ, .XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0[data-active=true] .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-input-selected-active-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0[data-dragged=true] {
  background-color: var(--chips-input-selected-dragged-bg, var(--chips-input-selected-default-bg));
  color: var(--chips-input-selected-dragged-text, var(--chips-input-selected-default-text));
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0[data-dragged=true] .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-input-selected-dragged-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0:disabled, .XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0[data-disabled=true] {
  background-color: var(--chips-input-selected-disabled-bg, var(--chips-input-selected-default-bg));
  color: var(--chips-input-selected-disabled-text, var(--chips-input-selected-default-text));
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0:disabled .ZMfJtfGwR8QpfGsEkDcQ, .XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0[data-disabled=true] .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-input-selected-disabled-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.k1bN552_KLOOtVkYGSh0[data-loading=true] {
  opacity: 0.7;
  pointer-events: none;
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya {
  background-color: var(--chips-assist-default-bg);
  color: var(--chips-assist-default-text);
  font-family: var(--chips-assist-font-family, inherit);
  font-size: var(--chips-assist-font-size, inherit);
  font-weight: var(--chips-assist-font-weight, inherit);
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-assist-default-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya:hover {
  background-color: var(--chips-assist-hover-bg, var(--chips-assist-default-bg));
  color: var(--chips-assist-hover-text, var(--chips-assist-default-text));
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya:hover .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-assist-hover-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya:focus-visible {
  background-color: var(--chips-assist-focused-bg, var(--chips-assist-default-bg));
  color: var(--chips-assist-focused-text, var(--chips-assist-default-text));
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya:focus-visible .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-assist-focused-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya:active, .XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya[data-active=true] {
  background-color: var(--chips-assist-active-bg, var(--chips-assist-default-bg));
  color: var(--chips-assist-active-text, var(--chips-assist-default-text));
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya:active .ZMfJtfGwR8QpfGsEkDcQ, .XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya[data-active=true] .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-assist-active-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya[data-dragged=true] {
  background-color: var(--chips-assist-dragged-bg, var(--chips-assist-default-bg));
  color: var(--chips-assist-dragged-text, var(--chips-assist-default-text));
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya[data-dragged=true] .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-assist-dragged-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya:disabled, .XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya[data-disabled=true] {
  background-color: var(--chips-assist-disabled-bg, var(--chips-assist-default-bg));
  color: var(--chips-assist-disabled-text, var(--chips-assist-default-text));
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya:disabled .ZMfJtfGwR8QpfGsEkDcQ, .XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya[data-disabled=true] .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-assist-disabled-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.mv5yU1V3H9bG9a4kL4ya[data-loading=true] {
  opacity: 0.7;
  pointer-events: none;
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz {
  background-color: var(--chips-primary-default-bg);
  color: var(--chips-primary-default-text);
  font-family: var(--chips-primary-font-family, inherit);
  font-size: var(--chips-primary-font-size, inherit);
  font-weight: var(--chips-primary-font-weight, inherit);
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-primary-default-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz:hover {
  background-color: var(--chips-primary-hover-bg, var(--chips-primary-default-bg));
  color: var(--chips-primary-hover-text, var(--chips-primary-default-text));
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz:hover .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-primary-hover-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz:focus-visible {
  background-color: var(--chips-primary-focused-bg, var(--chips-primary-default-bg));
  color: var(--chips-primary-focused-text, var(--chips-primary-default-text));
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz:focus-visible .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-primary-focused-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz:active, .XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz[data-active=true] {
  background-color: var(--chips-primary-active-bg, var(--chips-primary-default-bg));
  color: var(--chips-primary-active-text, var(--chips-primary-default-text));
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz:active .ZMfJtfGwR8QpfGsEkDcQ, .XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz[data-active=true] .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-primary-active-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz[data-dragged=true] {
  background-color: var(--chips-primary-dragged-bg, var(--chips-primary-default-bg));
  color: var(--chips-primary-dragged-text, var(--chips-primary-default-text));
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz[data-dragged=true] .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-primary-dragged-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz:disabled, .XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz[data-disabled=true] {
  background-color: var(--chips-primary-disabled-bg, var(--chips-primary-default-bg));
  color: var(--chips-primary-disabled-text, var(--chips-primary-default-text));
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz:disabled .ZMfJtfGwR8QpfGsEkDcQ, .XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz[data-disabled=true] .ZMfJtfGwR8QpfGsEkDcQ {
  background-color: var(--chips-primary-disabled-state-bg, transparent);
}
.XNlgAmOAkvrndqhQSeOw.NvYPOIXhdYCyoivoRCVz[data-loading=true] {
  opacity: 0.7;
  pointer-events: none;
}
.XNlgAmOAkvrndqhQSeOw .gI7SyPgTMjoBf0STdAwD {
  display: flex;
  align-items: center;
  gap: inherit;
  position: relative;
  z-index: 1;
}
.XNlgAmOAkvrndqhQSeOw .gI7SyPgTMjoBf0STdAwD span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.XNlgAmOAkvrndqhQSeOw .gI7SyPgTMjoBf0STdAwD svg,
.XNlgAmOAkvrndqhQSeOw .gI7SyPgTMjoBf0STdAwD i {
  min-height: 1em;
  min-width: 1em;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/UiKit/Chips/Chip/Chip.module.scss"],"names":[],"mappings":"AAmIA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAlIF;AAqIE;EAxIA,wEAAA;AAMF;AALE;EACE,wBAAA;AAOJ;AAJE;EACE,4EAAA;AAMJ;AAFI;EACE,uCAAA;EACA,iBAAA;EACA,kBAAA;AAIN;AA2HE;EA5IA,wEAAA;AAoBF;AAnBE;EACE,wBAAA;AAqBJ;AAlBE;EACE,4EAAA;AAoBJ;AAhBI;EACE,uCAAA;EACA,iBAAA;EACA,kBAAA;AAkBN;AAiHE;EAhJA,wEAAA;AAkCF;AAjCE;EACE,wBAAA;AAmCJ;AAhCE;EACE,4EAAA;AAkCJ;AA9BI;EACE,uCAAA;EACA,iBAAA;EACA,kBAAA;AAgCN;AAwGE;EAhIA,+CAAA;EACA,sCAAA;EAQA,oDAAA;EACA,gDAAA;EACA,oDAAA;AAoBF;AAjBE;EACE,kEAAA;AAmBJ;AAfE;EACE,4EAAA;EACA,qEAAA;AAiBJ;AAXI;EACE,gEAAA;AAaN;AARE;EACE,8EAAA;EACA,uEAAA;AAUJ;AAJI;EACE,kEAAA;AAMN;AADE;EAEE,6EAAA;EACA,sEAAA;AAEJ;AAII;EACE,iEAAA;AAFN;AAOE;EACE,8EAAA;EACA,uEAAA;AALJ;AAeI;EACE,kEAAA;AAbN;AAkBE;EAEE,+EAAA;EACA,wEAAA;AAjBJ;AA2BI;EACE,mEAAA;AAzBN;AA8BE;EACE,YAAA;EACA,oBAAA;AA5BJ;AA2DE;EApIA,wDAAA;EACA,+CAAA;EAQA,6DAAA;EACA,yDAAA;EACA,6DAAA;AAqEF;AAlEE;EACE,2EAAA;AAoEJ;AAhEE;EACE,8FAAA;EACA,uFAAA;AAkEJ;AA5DI;EACE,yEAAA;AA8DN;AAzDE;EACE,gGAAA;EACA,yFAAA;AA2DJ;AArDI;EACE,2EAAA;AAuDN;AAlDE;EAEE,+FAAA;EACA,wFAAA;AAmDJ;AA7CI;EACE,0EAAA;AA+CN;AA1CE;EACE,gGAAA;EACA,yFAAA;AA4CJ;AAlCI;EACE,2EAAA;AAoCN;AA/BE;EAEE,iGAAA;EACA,0FAAA;AAgCJ;AAtBI;EACE,4EAAA;AAwBN;AAnBE;EACE,YAAA;EACA,oBAAA;AAqBJ;AAcE;EAxIA,gDAAA;EACA,uCAAA;EAQA,qDAAA;EACA,iDAAA;EACA,qDAAA;AAsHF;AAnHE;EACE,mEAAA;AAqHJ;AAjHE;EACE,8EAAA;EACA,uEAAA;AAmHJ;AA7GI;EACE,iEAAA;AA+GN;AA1GE;EACE,gFAAA;EACA,yEAAA;AA4GJ;AAtGI;EACE,mEAAA;AAwGN;AAnGE;EAEE,+EAAA;EACA,wEAAA;AAoGJ;AA9FI;EACE,kEAAA;AAgGN;AA3FE;EACE,gFAAA;EACA,yEAAA;AA6FJ;AAnFI;EACE,mEAAA;AAqFN;AAhFE;EAEE,iFAAA;EACA,0EAAA;AAiFJ;AAvEI;EACE,oEAAA;AAyEN;AApEE;EACE,YAAA;EACA,oBAAA;AAsEJ;AA/BE;EA5IA,iDAAA;EACA,wCAAA;EAQA,sDAAA;EACA,kDAAA;EACA,sDAAA;AAuKF;AApKE;EACE,oEAAA;AAsKJ;AAlKE;EACE,gFAAA;EACA,yEAAA;AAoKJ;AA9JI;EACE,kEAAA;AAgKN;AA3JE;EACE,kFAAA;EACA,2EAAA;AA6JJ;AAvJI;EACE,oEAAA;AAyJN;AApJE;EAEE,iFAAA;EACA,0EAAA;AAqJJ;AA/II;EACE,mEAAA;AAiJN;AA5IE;EACE,kFAAA;EACA,2EAAA;AA8IJ;AApII;EACE,oEAAA;AAsIN;AAjIE;EAEE,mFAAA;EACA,4EAAA;AAkIJ;AAxHI;EACE,qEAAA;AA0HN;AArHE;EACE,YAAA;EACA,oBAAA;AAuHJ;AA5EE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AA8EJ;AA5EI;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA8EN;AA3EI;;EAEE,eAAA;EACA,cAAA;EACA,cAAA;AA6EN","sourcesContent":["@use \"sass:meta\";\n\n// Миксин для размеров чипов\n@mixin chip-size($size) {\n  border-radius: var(--chips-#{$size}-border-radius, var(--chips-border-radius));\n  .content {\n    gap: var(--chips-#{$size}-gap);\n  }\n\n  .state-layer {\n    padding: var(--chips-#{$size}-padding-vertical) var(--chips-#{$size}-padding-horizontal);\n  }\n\n  &.icon-only {\n    .state-layer {\n      padding: var(--chips-#{$size}-padding-square);\n      aspect-ratio: 1/1;\n      width: min-content;\n    }\n  }\n}\n\n// Миксин для цветовых стилей чипов\n@mixin chip-style($type) {\n  // Устанавливаем значения по умолчанию из CSS-переменных\n  background-color: var(--chips-#{$type}-default-bg);\n  color: var(--chips-#{$type}-default-text);\n\n  // Устанавливаем border если он есть\n  @if meta.variable-exists(--chips-#{$type}-default-border) {\n    border: var(--chips-#{$type}-default-border);\n  }\n\n  // Устанавливаем шрифт если есть соответствующие переменные\n  font-family: var(--chips-#{$type}-font-family, inherit);\n  font-size: var(--chips-#{$type}-font-size, inherit);\n  font-weight: var(--chips-#{$type}-font-weight, inherit);\n\n  // Стили для state-layer\n  .state-layer {\n    background-color: var(--chips-#{$type}-default-state-bg, transparent);\n  }\n\n  // Состояние hover\n  &:hover {\n    background-color: var(--chips-#{$type}-hover-bg, var(--chips-#{$type}-default-bg));\n    color: var(--chips-#{$type}-hover-text, var(--chips-#{$type}-default-text));\n\n    @if meta.variable-exists(--chips-#{$type}-hover-border) {\n      border: var(--chips-#{$type}-hover-border);\n    }\n\n    .state-layer {\n      background-color: var(--chips-#{$type}-hover-state-bg, transparent);\n    }\n  }\n\n  // Состояние focus\n  &:focus-visible {\n    background-color: var(--chips-#{$type}-focused-bg, var(--chips-#{$type}-default-bg));\n    color: var(--chips-#{$type}-focused-text, var(--chips-#{$type}-default-text));\n\n    @if meta.variable-exists(--chips-#{$type}-focused-border) {\n      border: var(--chips-#{$type}-focused-border);\n    }\n\n    .state-layer {\n      background-color: var(--chips-#{$type}-focused-state-bg, transparent);\n    }\n  }\n\n  // Состояние active\n  &:active,\n  &[data-active=\"true\"] {\n    background-color: var(--chips-#{$type}-active-bg, var(--chips-#{$type}-default-bg));\n    color: var(--chips-#{$type}-active-text, var(--chips-#{$type}-default-text));\n\n    @if meta.variable-exists(--chips-#{$type}-active-border) {\n      border: var(--chips-#{$type}-active-border);\n    }\n\n    .state-layer {\n      background-color: var(--chips-#{$type}-active-state-bg, transparent);\n    }\n  }\n\n  // Состояние dragged\n  &[data-dragged=\"true\"] {\n    background-color: var(--chips-#{$type}-dragged-bg, var(--chips-#{$type}-default-bg));\n    color: var(--chips-#{$type}-dragged-text, var(--chips-#{$type}-default-text));\n\n    @if meta.variable-exists(--chips-#{$type}-dragged-border) {\n      border: var(--chips-#{$type}-dragged-border);\n    }\n\n    @if meta.variable-exists(--chips-#{$type}-dragged-box-shadow) {\n      box-shadow: var(--chips-#{$type}-dragged-box-shadow);\n    }\n\n    .state-layer {\n      background-color: var(--chips-#{$type}-dragged-state-bg, transparent);\n    }\n  }\n\n  // Состояние disabled\n  &:disabled,\n  &[data-disabled=\"true\"] {\n    background-color: var(--chips-#{$type}-disabled-bg, var(--chips-#{$type}-default-bg));\n    color: var(--chips-#{$type}-disabled-text, var(--chips-#{$type}-default-text));\n\n    @if meta.variable-exists(--chips-#{$type}-disabled-border) {\n      border: var(--chips-#{$type}-disabled-border);\n    }\n\n    @if meta.variable-exists(--chips-#{$type}-disabled-opacity) {\n      opacity: var(--chips-#{$type}-disabled-opacity);\n    }\n\n    .state-layer {\n      background-color: var(--chips-#{$type}-disabled-state-bg, transparent);\n    }\n  }\n\n  // Состояние loading\n  &[data-loading=\"true\"] {\n    opacity: 0.7;\n    pointer-events: none;\n  }\n}\n\n// Базовые стили для чипов\n.chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: pointer;\n  position: relative;\n\n  // Размеры\n  &.sm {\n    @include chip-size(\"sm\");\n  }\n\n  &.md {\n    @include chip-size(\"md\");\n  }\n\n  &.lg {\n    @include chip-size(\"lg\");\n  }\n\n  // Стили чипов\n  &.input {\n    @include chip-style(\"input\");\n  }\n\n  &.input-selected {\n    @include chip-style(\"input-selected\");\n  }\n\n  &.assist {\n    @include chip-style(\"assist\");\n  }\n\n  &.primary {\n    @include chip-style(\"primary\");\n  }\n\n  .content {\n    display: flex;\n    align-items: center;\n    gap: inherit;\n    position: relative;\n    z-index: 1;\n\n    span {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    svg,\n    i {\n      min-height: 1em;\n      min-width: 1em;\n      flex-shrink: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chip": `XNlgAmOAkvrndqhQSeOw`,
	"sm": `_kNMDHyPE7Y2uykKeXzL`,
	"content": `gI7SyPgTMjoBf0STdAwD`,
	"state-layer": `ZMfJtfGwR8QpfGsEkDcQ`,
	"icon-only": `if88F_Hs1SDOjx4kBgZn`,
	"md": `iwPLQ9yqq_PvXBURHVU2`,
	"lg": `K8WRj_P93vnUooCkTtqW`,
	"input": `jqvs6fx1yRny94GEIdbe`,
	"input-selected": `k1bN552_KLOOtVkYGSh0`,
	"assist": `mv5yU1V3H9bG9a4kL4ya`,
	"primary": `NvYPOIXhdYCyoivoRCVz`
};
export default ___CSS_LOADER_EXPORT___;
